
import translations from './translations'
import langEN from 'element-ui/lib/locale/lang/en'
import langCN from 'element-ui/lib/locale/lang/zh-CN'
import localeEl from 'element-ui/lib/locale'
const languePlugin = {
    install: function (Vue, options) {
        const _lang = sessionStorage.getItem('_lang') || options.locale
        localeEl.use(_lang == 'zh' ? langCN : langEN)
        const locale = new Vue({
            data() {
                return {
                    locale: _lang,
                };
            },
        });
        Vue.prototype.$locale = locale.locale
        Vue.prototype.$setLocale = function (newLocale) {
            locale.locale = newLocale
            this.$locale = locale.locale
            sessionStorage.setItem('_lang', locale.locale)
            localeEl.use(locale.locale == 'zh' ? langCN : langEN)
            location.reload();
        };
        Vue.prototype.$l = function (key) {
            const langs = ['en', 'ja']
            const index = langs.indexOf(locale.locale)
            const translation = index == -1 ? key : ((translations[key] && translations[key][index]) || key);
            return translation;
        };
    }
};

export default languePlugin;